import { render, staticRenderFns } from "./weixinAPIConfigure.vue?vue&type=template&id=5fa9fa42&scoped=true"
import script from "./weixinAPIConfigure.vue?vue&type=script&lang=js"
export * from "./weixinAPIConfigure.vue?vue&type=script&lang=js"
import style0 from "./weixinAPIConfigure.vue?vue&type=style&index=0&id=5fa9fa42&prod&scoped=true&lang=css"
import style1 from "./weixinAPIConfigure.vue?vue&type=style&index=1&id=5fa9fa42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa9fa42",
  null
  
)

export default component.exports